import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 審閱契約 確認頁 PostBack
 */
const ContractConfirmPostBack = [
    'POST',
    RouteUrlList.API_ContractConfirmPostBack.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];
export default ContractConfirmPostBack;
